import { FC } from "react"
import { IconInfo, Text } from "dash-styled"

interface TrimmedWarningProps {
    className?: string
}

export const TrimmedWarning: FC<TrimmedWarningProps> = ({ className }) => (
    <div
        className={`flex items-center bg-rhino-250 rounded pr-4 pl-3 text-smoke-350 ${
            className ?? ""
        }`}
    >
        <IconInfo />
        <Text className="text-rhino-800 pl-2 text-xs m-2">
            Only the first row of data will be considered for now. Once you're
            set up you can upload more.
        </Text>
    </div>
)
